import React, { useState } from 'react';
import { Button, Form, Input, Card, Row, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { handleAuth } from '../core/auth';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { LoginQuery, ResendConfirmationToken } from '../shared/common/graphqlQuery';
import { useLazyQueryHook } from '../shared/hooks/useLazyQueryHook';
import { Brand_Name, routeConfig } from '../shared/common/constant';
import { validateNameMessages } from '../shared/hooks/utils';
import AccountPageShowBrand from '../shared/components/accountPageShowBrand/accountPageBrand';
import { useMutationHook } from '../shared/hooks/useMutationHook';

const LoginComponent = () => {
    const { state } = useLocation();
    const history = useHistory();
    const [loginError, setLoginError] = useState<string>('');
    const [userEmail, setUserEmail] = useState<any>('');
    const goToPage = (pageUrl: string) => {
        history.push(pageUrl);
    }
    const onSubmitted = (result: any) => {
        handleAuth(result.login);
        if (result.login.activeCompanyDetails?._id) {
            goToPage((state && state['from']?.pathname !== '/' && state['from']?.pathname) || routeConfig.home.path);
        } else {
            goToPage(routeConfig.createCompany.path);
        }
    }

    const onError = ({ graphQLErrors, networkError }: any) => {
        console.log(graphQLErrors, networkError, 'errors');
        if (graphQLErrors[0].message === 'AUTHENTICATION_ERROR') {
            setLoginError('You have entered an invalid username or password');
        } else {
            setLoginError(graphQLErrors[0].message);
        }
        if (graphQLErrors[0].message == ' Your account has not been verified.') {
            callMutation({ variables: { email: userEmail } });
            
        }
    }

    const onSubmit = (result)  => {
        message.success('A Verification link has been sent to your email account.');
    }
    const onErrorResnd = () => {
        
    }

    const { callLazyQuery, loading } = useLazyQueryHook(LoginQuery, onSubmitted, onError);
    const { callMutation } = useMutationHook(ResendConfirmationToken, onSubmit, onErrorResnd);


    const onFinish = ({ email, password }: any) => {
        if (!loading) {
            setUserEmail(email);
            callLazyQuery({ variables: { email, password } });
        }
    }
    return (
        <div className="center">
            <div className="card">
                <AccountPageShowBrand />
                <Card title="Log in to Export Docs" bordered={false} className='loginForm'>
                    <Form name="basic" onFinish={onFinish} validateMessages={validateNameMessages} validateTrigger='onSubmit' initialValues={null}>
                        <Form.Item name="email" rules={[{ required: true, whitespace: true, type: 'email' }]} >
                            <Input size="large" placeholder="E-mail" />
                        </Form.Item>
                        <Form.Item name="password" rules={[{ required: true, whitespace: true }]}>
                            <Input.Password size="large" placeholder="Password" />
                        </Form.Item>
                        <Form.Item>
                            <Button size="large" type="primary" htmlType="submit" style={{ width: '100%' }}>
                                {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Sign in'}
                            </Button>
                        </Form.Item>
                        {loginError ? <div className="error__color error__align">{loginError}</div> : ''}
                        <div className="sign-up">
                            <Button type="link"><Link to={routeConfig.register.path}>Create {Brand_Name} Account</Link></Button> |
                            <Button type="link"><Link to={routeConfig.forgotPassword.path}>Forgot password</Link></Button>
                        </div>
                    </Form>
                </Card>
            </div>
        </div>
    );
}
export default LoginComponent